import {UserBanner, Spinner, BlogsTable} from '../components'


import React, {useEffect, useState} from "react";

import {useNavigate, Link} from "react-router-dom";
import {baseurl, getParcel} from '../services/service'
import {DeleteOutline, NavigateBefore, NavigateNext} from "@mui/icons-material";
import {Parcletable} from '../components/index'

const Landing = () => {

    const [data, setData] = useState(false)
    const getParcellist = async (page) => {
        const token = JSON.parse(localStorage.getItem('admin'))
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                take: 10, page: page,
            }
        }
        const response = await getParcel(config)

        if (response) {
           setData(response.data)

        }

    }
    useEffect(() => {



            getParcellist()



    }, []);


    let content
    if (data !== false) {
        if (data.items.length > 0) {
            content = <Parcletable>
                {data.items.map((item) => {
                    return (
                        <>
                            <tr key={item.id} className='has-text-centered yekan'>

                                <td>{item.parcels.tracking_code}</td>
                                <td>{item.cities.name}</td>
                                <td>{item.parcels.sender_name}</td>
                                <td>{item.parcels.sender_phone}</td>
                                <td>{item.parcels.receiver_name}</td>
                                <td>{item.parcels.receiver_phone}</td>
                                <td>{item.parcels.address}</td>
                                <td>{item.parcels.type}</td>


                            </tr>
                        </>

                    )
                })}
            </Parcletable>
        } else {
            content =
                <div className='column is-12'>
                    <p className='my-3'>
                        چیزی برای نمایش وجود ندارد 🤷‍♀️

                    </p>
                </div>

        }


    } else {
        content = <div className='column is-12'>
            <Spinner/>
        </div>
    }

    return (
        <>
            <div className='columns m-0 is-multiline'>


                <UserBanner/>

                <div className='column is-12 welcome__master p-5 my-4 '>
                    {
                        content
                    }

                    <div className='column is-12'>
                        {data &&
                            <div className='pinar' style={{display: 'flex', justifyContent: 'center'}}>


                                {/*before page with tick*/}
                                {
                                    data.paginator.beforePage < data.paginator.currentPage && (

                                        <button onClick={() => getParcellist(data.paginator.beforePage)} className='button'>
                                            <NavigateNext/>
                                        </button>
                                    )


                                }


                                {/*map beforePages*/}
                                {data.paginator.beforePages.length > 0 &&

                                    <>
                                        {data.paginator.beforePages.map((item, index) =>
                                            <button className='button' onClick={() => getParcellist(item)} key={index}>
                                                {item}
                                            </button>
                                        )}
                                    </>

                                }


                                {/*active*/}

                                {
                                    data.paginator.total > 0 &&
                                    <button
                                        className='clrtwo has-text-white button'>{data.paginator.currentPage}</button>


                                }


                                {/*map nextPages*/}
                                {data.paginator.nextPages.length > 0 &&
                                    <>
                                        {data.paginator.nextPages.map((item, index) =>
                                            <button className='button' onClick={() => getParcellist(item)} key={index}>
                                                {item}
                                            </button>
                                        )}
                                    </>

                                }


                                {/*next page with tick*/}
                                {

                                    data.paginator.nextPage > data.paginator.currentPage && (

                                        <button onClick={() => getParcellist(data.paginator.nextPage)}
                                                className='button is-transparent'>
                                            <NavigateBefore/>
                                        </button>
                                    )


                                }


                            </div>
                        }
                    </div>


                </div>


            </div>

        </>
    )
}
export default Landing;